module.exports = __webpack_public_path__ + "static/media/kirke_logo.7f8860a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kirke_logo.svg
// module id = 532
// module chunks = 0